export default __webpack_public_path__ + "static/grasp-a97ba15718fc9060466dd6ed48bd887f.png";